// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as PartnerScoreConfig from "../../../domain/store/PartnerScoreConfig.bs.js";
import * as PartnerScoreAssetConfig from "../../assets/PartnerScoreAssetConfig.bs.js";

function PartnerScoreErrorCmp(Props) {
  var reload_cb = Props.reload_cb;
  return React.createElement("div", {
              className: "c-partner-score-error-wrapper"
            }, React.createElement("div", {
                  className: "partner-score-error-container"
                }, React.createElement("div", {
                      className: "partner-score-error-image-container"
                    }, React.createElement("img", {
                          className: "partner-score-error-image",
                          src: PartnerScoreAssetConfig.error_img
                        })), React.createElement("div", {
                      className: "partner-score-error-content-container"
                    }, React.createElement("div", {
                          className: "partner-score-error-title"
                        }, PartnerScoreConfig.errorCmpTitle), React.createElement("button", {
                          className: "partner-score-error-reload-btn",
                          onClick: (function (param) {
                              return Curry._1(reload_cb, undefined);
                            })
                        }, React.createElement("div", {
                              className: "reload-text"
                            }, PartnerScoreConfig.reloadBtnText)))));
}

var make = PartnerScoreErrorCmp;

export {
  make ,
  
}
/* react Not a pure module */
